import * as types from "./constants";

export const getPerformanceTestResult = (payload) => ({
  type: types.GET_PERFORMANCE_TEST_RESULT,
  payload,
});
export const getPerformanceTestResultLoading = () => ({
  type: types.GET_PERFORMANCE_TEST_RESULT_LOADING,
});
export const getPerformanceTestResultSuccess = (payload) => ({
  type: types.GET_PERFORMANCE_TEST_RESULT_SUCCESS,
  payload,
});
export const getPerformanceTestResultError = (payload) => ({
  type: types.GET_PERFORMANCE_TEST_RESULT_ERROR,
  payload,
});

export const getAllUserTestResult = (payload) => ({
  type: types.GET_ALL_USER_TEST_RESULT,
  payload,
});
export const getAllUserTestResultLoading = () => ({
  type: types.GET_ALL_USER_TEST_RESULT_LOADING,
});
export const getAllUserTestResultSuccess = (payload) => ({
  type: types.GET_ALL_USER_TEST_RESULT_SUCCESS,
  payload,
});
export const getAllUserTestResultError = (payload) => ({
  type: types.GET_ALL_USER_TEST_RESULT_ERROR,
  payload,
});
